"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ToastContext_1 = require("context/ToastContext");
const useLocale_1 = require("hooks/useLocale");
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const TooltipContainer_1 = __importDefault(require("components/shared/Tooltips/TooltipContainer"));
const CommentBox_1 = __importDefault(require("./CommentBox"));
const MultipleChoice_1 = __importDefault(require("./MultipleChoice"));
const SurveyResultHelper_1 = require("./SurveyResultHelper");
const COLORTHEME = ['v', 'y', 'cy', 'l', 'o', 'i', 'f', 'e', 'r', 'b', 'n'];
const CardBoxSurvey = ({ orderLevel, voterCount, pollOptions, question, type, occurrenceId, surveyId, essayId }) => {
    const questionRef = (0, react_1.useRef)(null);
    const { addToast } = (0, ToastContext_1.useToastContext)();
    const { setBothLocale } = (0, useLocale_1.useLocale)();
    const copyCard = async (dom) => {
        addToast({
            title: 'Copying',
            type: 'info'
        });
        const { isSuccess } = await (0, SurveyResultHelper_1.copyToClipboard)({ dom });
        addToast({
            title: isSuccess
                ? 'Chart copied to clipboard'
                : 'Failed copy chart to clipboard',
            type: isSuccess ? 'info' : 'error'
        });
    };
    return (react_1.default.createElement("div", { className: "flex justify-center" },
        react_1.default.createElement("div", { className: "w-[1040px] border border-solid border-n-400 bg-n-000 rounded-[8px] p-[24px]", ref: questionRef },
            react_1.default.createElement("div", { className: "flex flex-row justify-between items-center mb-[24px]" },
                react_1.default.createElement("h1", { className: "typography-h600 text-n-900 my-0" }, setBothLocale(`Question ${orderLevel + 1}`)),
                type == 'poll' && (react_1.default.createElement(TooltipContainer_1.default, { show: true, text: "Copy chart", classContainer: "cursor-pointer", position: "bottom", align: "left", useMaxWidth: false },
                    react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-content_copy", size: 24, fillColor: "var(--n-600)", onClick: () => {
                            questionRef.current && copyCard(questionRef.current);
                        } })))),
            react_1.default.createElement("p", { className: "typography-h500 text-n-800 mb-[24px]" }, question),
            type == 'poll' && (react_1.default.createElement(MultipleChoice_1.default, { colorTheme: COLORTHEME, pollOptions: pollOptions, voterCount: voterCount })),
            type !== 'poll' && (react_1.default.createElement(CommentBox_1.default, { surveyId: surveyId, occurrenceId: occurrenceId, essayId: essayId })))));
};
exports.default = CardBoxSurvey;
